export class SetIsEditing {
  static readonly type = '[Editing] Set is editing';

  constructor(public isEditing: boolean) {}
}

export class SetIsEditingModalOpen {
  static readonly type = '[Editing] Set is editing modal open';

  constructor(public isEditingModalOpen: boolean) {}
}

export class SetCloseResult {
  static readonly type = '[Editing] Set close result';

  constructor(public closeResult: boolean|null) {}
}
